import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button } from '@mui/material';
import { getCandidateCreatedBy } from './services';
import Papa from 'papaparse';

const tableStyle = {
  minWidth: 650,
};

const ProfileCreationReport = () => {
  const [data, setData] = useState([]);
  const [passportNumbers, setPassportNumbers] = useState('');

  const handleSearch = () => {
    const passportNosArray = passportNumbers.split(',').map((passportNo) => passportNo.trim());

    getCandidateCreatedBy(passportNosArray).then((res) => {
      setData(res.data);
    });
  };

  const handleExportCSV = () => {
    if (data.length === 0) {
      alert('No data to export.');
      return;
    }

    const csvData = Papa.unparse(data);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'exported_data.csv';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div style={{
        marginTop: '16px',
    }}>
      <TextField
        label="Passport Numbers (comma-separated)"
        variant="outlined"
        fullWidth
        value={passportNumbers}
        onChange={(e) => setPassportNumbers(e.target.value)}
      />
      <Button variant="contained" onClick={handleSearch} style={{ marginTop: '16px' }}>
        Search
      </Button>
      <Button variant="contained" onClick={handleExportCSV} style={{ marginTop: '16px', marginLeft: '16px' }}>
        Export CSV
      </Button>
      <TableContainer component={Paper} style={{ marginTop: '16px' }}>
  <Table style={tableStyle}>
    <TableHead>
      <TableRow>
        <TableCell>Candidate Name</TableCell>
        <TableCell>RegNumber</TableCell>
        <TableCell>Passport Number</TableCell>
        <TableCell>Created By</TableCell>
        <TableCell>Update Percentage</TableCell>
        <TableCell>Updated Fields</TableCell> {/* New column for updated fields */}
      </TableRow>
    </TableHead>
    <TableBody>
      {data.map((row, index) => (
        <TableRow key={index}>
          <TableCell>{row?.CandidateName}</TableCell>
          <TableCell>{row?.RegNumber}</TableCell>
          <TableCell>{row?.passportNo}</TableCell>
          <TableCell>{row?.CreatedBy}</TableCell>
          <TableCell>{row?.UpdatePercentage}</TableCell>
          <TableCell>
            {/* Display updated fields as a comma-separated list */}
            {row?.UpdatedFields.join(', ')}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>

    </div>
  );
};

export default ProfileCreationReport;
